<template>
  <TheHeader>
    <div class="contents-wrapper-01">
      <div class="bbs_title">
        1:1 문의
        <p v-if="isPC" class="flow">관리자와 1:1 상담을 할 수 있습니다.</p>
        <slot name="buttons" />
        <a-button
          style="margin: 5px;"
          shape="round"
          type="dashed"
          v-if="isPC"
          class="fl-right"
          @click="$router.go(-1)"
          icon="rollback"
        >뒤로가기</a-button>
      </div>
      <div class="acc-content-wrapper type2">
        <slot />
      </div>
    </div>
  </TheHeader>
</template>
<script>
import TheHeader from "../TheLayout/TheHeader";

export default {
  name: "TheQuestion",
  components: { TheHeader },
  data() {
    return {
      status: "status"
    };
  }
};
</script>